module.exports = __webpack_public_path__ + "static/v&b-e94c0e8875d5df86b080d2a56de722f1.png";